export function PixelScene(): React.JSX.Element {
  return (
    <div className="pixel-scene" aria-hidden="true">
      <div className="moon" />
      <div className="star star-one" />
      <div className="star star-two" />
      <div className="star star-three" />
      <div className="city city-back" />
      <div className="city city-front" />
      <div className="window-glow window-a" />
      <div className="window-glow window-b" />
      <div className="window-glow window-c" />
      <div className="rain rain-one" />
      <div className="rain rain-two" />
    </div>
  );
}
